import React from 'react';
import { Avatar, Button } from 'components/ui';
import withHeaderItem from 'utils/hoc/withHeaderItem';
import useAuth from 'utils/hooks/useAuth';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import { HiOutlineUser, HiOutlineLogout } from 'react-icons/hi';

export const UserDropdown = ({ className }) => {
  const user = useSelector((state) => state.auth.user);
  const role = user?.role?.length > 0 ? user.role[0] : 'user';
  const avatar = user?.image_url;
  const roleText = role.charAt(0).toUpperCase() + role.slice(1);
  const roleFinalText =
    roleText === 'Doctor' ? 'Médico' : roleText === 'Admin' ? 'Admin' : 'Paciente';

  const { signOut } = useAuth();
  const navigate = useNavigate();

  const handleUserClick = () => {
    navigate('/admin/consultas');
  };

  return (
    <div className={classNames(className, 'flex items-center gap-3')}>
      {/* Botão do usuário - clicável para ir para consultas */}
      <button
        onClick={handleUserClick}
        className="flex items-center gap-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg p-2 transition-colors"
      >
        {avatar ? (
          <Avatar size={32} src={avatar} shape="circle" />
        ) : (
          <Avatar size={32} shape="circle" icon={<HiOutlineUser />} />
        )}
        <div className="hidden md:block text-left">
          <div className="text-xs capitalize text-gray-600 dark:text-gray-400">{roleFinalText}</div>
          <div className="font-bold text-gray-900 dark:text-gray-100">{user.firstname}</div>
        </div>
      </button>

      {/* Botão de signout */}
      <Button
        variant="plain"
        shape="circle"
        size="sm"
        icon={<HiOutlineLogout />}
        onClick={signOut}
        className="text-gray-600 hover:text-red-500 dark:text-gray-400 dark:hover:text-red-400"
        title="Sair"
      />
    </div>
  );
};

export default withHeaderItem(UserDropdown);
